import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled } from '@mui/material';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _excluded = ["className"];
var componentRowLink = createComponentSlot({
  name: "CinTable",
  slot: "RowLink"
});

var RowLinkCellBase = function RowLinkCellBase(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classnames(componentRowLink.className, className)
  }));
};

var RowLinkCell = styled(RowLinkCellBase, _objectSpread2(_objectSpread2({}, componentRowLink.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))({
  padding: 16
});
var RowLinkCell$1 = RowLinkCell;

export { RowLinkCell$1 as default };
